/**
 * Selected card state for the Card Details Panel
 */
import { atom, useAtom } from 'jotai';

/** ID of the currently selected card in collection, null when panel is closed */
const selectedCardIdAtom = atom<string | null>(null);

export interface UseSelectedCardResult {
  /** Currently selected card ID */
  selectedCardId: string | null;
  /** Open the details panel for a card */
  selectCard: (cardId: string) => void;
  /** Close the details panel */
  clearSelection: () => void;
}

/**
 * Hook for managing selected card state (Card Details Panel)
 */
export default function useSelectedCard(): UseSelectedCardResult {
  const [selectedCardId, setSelectedCardId] = useAtom(selectedCardIdAtom);

  const selectCard = (cardId: string) => setSelectedCardId(cardId);
  const clearSelection = () => setSelectedCardId(null);

  return {
    selectedCardId,
    selectCard,
    clearSelection,
  };
}
